import axios from 'ps-components/lib/apiClient';
import { useMutation, useQuery, useQueryClient } from 'react-query'

const getCommands = async () => {
    const response = await axios.apiGet('/api/marketpay-internal/tableau-admin/commands')
    return response.data?.success ? response.data.commands : {}
}

const updateCommand = async (payload: { command: string, enabled: boolean }) => {
    const response = await axios.apiPut('/api/marketpay-internal/tableau-admin/commands', payload)
    console.log(response)
}

export const useGetCommandsQuery = () => useQuery({ queryKey: ['tableau-commands'], queryFn: getCommands, staleTime: 6000000 })

export const useUpdateCommandMutation = () => {
    const queryClient = useQueryClient()

    return useMutation(updateCommand, {
    onMutate: async ({ command, enabled }) => {
        await queryClient.cancelQueries('tableau-commands')
        const previousItems = queryClient.getQueryData('tableau-commands')
        queryClient.setQueryData('tableau-commands', (prev: any) => ({ ...prev, [command]: enabled }));
        return { previousItems }
    },
    onError: (err, _, context) => {
        console.error(err)
        queryClient.setQueryData('tableau-commands', context?.previousItems);
    },
    onSettled: () => {
        queryClient.invalidateQueries('tableau-commands');
    }
})}